var PARALLAX_SPEED = 0.2;
function parallaxBaseForContainer(container) {
    var rect = container.getBoundingClientRect();
    var windowHeight = window.innerHeight;
    var containerCenter = rect.top + rect.height / 2;
    var viewportCenter = windowHeight / 2;
    return containerCenter - viewportCenter;
}
/**
 * Parallax for server-rendered blocks (home stage, optional hero).
 * Keeps initial transform at 0 until layout has settled (double rAF).
 */
function initParallaxContainer(container, itemSelector) {
    var items = container.querySelectorAll(itemSelector);
    if (!items.length) {
        return;
    }
    var enabled = false;
    var rafId = null;
    var update = function () {
        rafId = null;
        var base = parallaxBaseForContainer(container);
        var isMobile = window.innerWidth < 1024;
        items.forEach(function (item) {
            var offset = base * PARALLAX_SPEED;
            if (isMobile) {
                offset = Math.max(offset, -15);
            }
            item.style.transform = enabled ? "translateY(".concat(offset, "px)") : 'translateY(0)';
        });
    };
    var schedule = function () {
        if (rafId === null) {
            rafId = requestAnimationFrame(update);
        }
    };
    requestAnimationFrame(function () {
        requestAnimationFrame(function () {
            enabled = true;
            update();
        });
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
}
export function initHomeStageParallax() {
    document.querySelectorAll('[data-home-stage-parallax]').forEach(function (container) {
        initParallaxContainer(container, '.home-stage__parallax-cell');
    });
    document.querySelectorAll('[data-cowp-hero-parallax]').forEach(function (container) {
        initParallaxContainer(container, '.cowp-hero__parallax-cell');
    });
}
